/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
/**
 * Import Component
 */
import ItemOptionsTotal from '../../components/ItemOptionsTotal'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    stash: state.stash,
    stashByOptionGroups: state.stashByOptionGroups,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ItemOptionsTotal)))



// WEBPACK FOOTER //
// ./src/containers/components/ItemOptionTotal.js